import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: false
})
export class TopBarComponent {

  @Input() title: string = "";
  @Input() showHomeBtn = false;
  @Input() customBack?: () => void;

  constructor(
    private location: Location,
    private router: Router,
  ) { }

  close(): void {
    if (this.customBack) {
      this.customBack();
      return;
    }

    const fullPath = this.location.path(true);
    const path = fullPath.split('#')[0];
    const hash = fullPath.includes('#__hc-action-cancel');

    if (hash) {
      this.location.replaceState(path);
      this.location.historyGo(-2);
    } else {
      this.location.back();
    }
  }

  backToHome(): void {
    this.router.navigate(['']);
  }
}
